import React, { useState } from 'react';
import { getBureauDisplayName, getBureauLogoUrl } from '../../utils/bureauLogos';

/**
 * Renders a bureau logo from local SVG assets with CDN/text fallbacks.
 */
export const BureauLogo = ({
  bureau,
  className = '',
  style = {},
  isDark = false,
  height = '2rem',
  maxWidth = '140px',
}) => {
  const [imageStage, setImageStage] = useState('local');
  const displayName = getBureauDisplayName(bureau);

  const logoUrl =
    imageStage === 'local'
      ? getBureauLogoUrl(bureau)
      : imageStage === 'cdn'
        ? getBureauLogoUrl(bureau, { preferFallback: true })
        : null;

  if (!logoUrl || imageStage === 'text') {
    return (
      <span
        className={`inline-flex items-center justify-center font-bold tracking-tight ${className}`}
        style={{
          height,
          maxWidth,
          fontSize: '1rem',
          color: isDark ? '#E5E7EB' : '#111827',
          ...style,
        }}
        aria-label={displayName}
      >
        {displayName}
      </span>
    );
  }

  return (
    <img
      src={logoUrl}
      alt={displayName}
      className={`object-contain ${className}`}
      style={{
        height,
        width: 'auto',
        maxWidth,
        filter: isDark ? 'brightness(1.15) contrast(1.05)' : 'none',
        imageRendering: 'auto',
        ...style,
      }}
      onError={() => {
        if (imageStage === 'local') {
          setImageStage('cdn');
          return;
        }
        setImageStage('text');
      }}
    />
  );
};

export default BureauLogo;
